import "select2"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"
import "select2/dist/js/i18n/he"
import "select2/dist/js/i18n/ru"
import "select2/dist/js/i18n/en"
import DynDataAdapter from "../libs/dynDataAdapter";

export default context => {
    $('select.searchable', context).each(function () {
        $(this).select2({
            theme: 'bootstrap',
            width: '100%',
            dropdownParent: $(this).closest('.modal-body,.bootstrap-isolated'),
            ajax: {
                url: '/site/options/select-list',
                data: function (params) {
                    params.id = $(this).closest('.form-group').data('optid')
                    return params
                },
                dataType: 'json',
                processResults: function (data) {
                    let result = []
                    for (const [id, text] of Object.entries(data)) {
                        result.push({id, text})
                    }
                    return {
                        results: result
                    };
                },
                cache: true,
            },
            minimumInputLength: 0,
        })
    })
    $('select.static-search', context).select2({
        theme: 'bootstrap',
        width: '100%',
        dropdownParent: $('#EditGroupForm')
    });

    $('#editOptionPlusDetailsShareCommunities .edit-option-form select[name^="default"]:not(.processed)', context).each(function () {
        const selector = $(this)
        selector.addClass('processed')
        selector.select2({
            theme: 'bootstrap',
            width: '100%',
            dropdownParent: $(this).closest('.bootstrap-isolated'),
            dataAdapter: DynDataAdapter,
            minimumInputLength: 0,
            queryCallback: function (params) {
                let duplicates = []
                return selector
                    .parents('.edit-option-form')
                    .find('.share-communities-widget label.btn-tags.active input[type="checkbox"]')
                    .filter(function (index) {
                        const val = $(this).val()
                        if (duplicates.indexOf(val) > -1 || $(this).data('label').indexOf(params.term) === -1) {
                            return false
                        }
                        duplicates.push(val)
                        return true
                    })
                    .map(function () {
                        return {id: $(this).val(), text: $(this).data('label')}
                    })
                    .get()
            }
        })
    })

    $('.edit-option-form select[name^="default"]:not(.processed)', context).each(function () {
        const selector = $(this)
        selector.addClass('processed')
        selector.select2({
            theme: 'bootstrap',
            width: '100%',
            dropdownParent: $(this).closest('.bootstrap-isolated'),
            dataAdapter: DynDataAdapter,
            minimumInputLength: 0,
            queryCallback: function (params) {
                return selector
                    .parents('.edit-option-form').find('.multi-values .values_content input[type="text"]')
                    .map(function () {
                        const val = $(this).val()
                        return {id: val, text: val}
                    })
                    .get()
                    .filter(item => item.text.indexOf(params.term) > -1)
            }
        })
    })
}
